export function normalizarFechaIso(valor) {
  const raw = String(valor || '').trim();
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return '';
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day
    ? raw
    : '';
}

export function calcularEdad(fechaIso, hoy = new Date()) {
  const [year, month, day] = fechaIso.split('-').map(Number);
  let edad = hoy.getFullYear() - year;
  if (hoy.getMonth() + 1 < month || (hoy.getMonth() + 1 === month && hoy.getDate() < day)) edad -= 1;
  return edad;
}

export function validarFechaNacimiento(valor, hoy = new Date()) {
  const fecha = normalizarFechaIso(valor);
  if (!fecha) return 'La fecha de nacimiento es obligatoria y debe ser válida.';
  if (calcularEdad(fecha, hoy) < 0) return 'La fecha de nacimiento no puede ser en el futuro.';
  return '';
}

export function validarDni(valor) {
  return /^\d{7,8}$/.test(String(valor || '').trim())
    ? ''
    : 'El DNI debe contener 7 u 8 dígitos numéricos.';
}

export function validarTelefono(valor) {
  const telefono = String(valor || '').trim();
  const digitos = telefono.replace(/\D/g, '');
  if (!/^[\d\s+()-]+$/.test(telefono) || digitos.length < 8 || digitos.length > 15) {
    return 'El teléfono debe contener entre 8 y 15 dígitos válidos.';
  }
  return '';
}

export function validarDomicilio(valor) {
  const domicilio = String(valor || '').trim();
  if (!domicilio) return 'El domicilio es obligatorio.';
  return domicilio.length >= 3 && domicilio.length <= 160
    ? ''
    : 'El domicilio debe contener entre 3 y 160 caracteres.';
}

export function validarCuit(valor) {
  const cuit = String(valor || '').replace(/\D/g, '');
  if (!cuit) return '';
  if (!/^\d{11}$/.test(cuit)) return 'El CUIT debe contener 11 dígitos.';
  const factores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const suma = factores.reduce((total, factor, index) => total + Number(cuit[index]) * factor, 0);
  const resto = 11 - (suma % 11);
  const verificador = resto === 11 ? 0 : resto === 10 ? 9 : resto;
  return verificador === Number(cuit[10]) ? '' : 'El CUIT ingresado no es válido.';
}

export function validarNumeroAfiliado(valor, obligatorio = false) {
  const numero = String(valor || '').trim();
  if (!numero) return obligatorio ? 'El número de afiliado es obligatorio.' : '';
  return /^[A-Za-z0-9][A-Za-z0-9 ./-]{2,29}$/.test(numero)
    ? ''
    : 'El número de afiliado no tiene un formato válido.';
}
